export default "__VITE_ASSET__7vz3V7yT__"